import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LIBRARY_TRANSLATIONS, flattenTranslations } from '@card-software/library';

type TranslationNode = Record<string, unknown>;

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly translationsUrl = 'assets/i18n/translations.json';

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationNode>(this.translationsUrl).pipe(
      // App translations win over the library's own (filters panel, nav menu…) when a key exists in both.
      map((translations) => ({ ...flattenTranslations(LIBRARY_TRANSLATIONS, lang), ...this.flattenTranslations(translations, lang) })),
    );
  }

  private flattenTranslations(obj: TranslationNode, lang: string, prefix = ''): Record<string, string> {
    let result: Record<string, string> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const newKey = prefix ? `${prefix}.${key}` : key;
        const node = obj[key] as TranslationNode;
        if (typeof node === 'object' && node[lang] === undefined) {
          result = { ...result, ...this.flattenTranslations(node, lang, newKey) };
        } else if (node[lang] !== undefined) {
          result[newKey] = node[lang] as string;
        }
      }
    }
    return result;
  }
}
